module.exports = __webpack_public_path__ + "images/for_company_page/title-number1_75edb120210316017b9729646da3b0ee.jpg";